var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"col":"3"}},[_c('WidgetsDropdown')],1),_c('CCol',{attrs:{"col":"3"}},[_c('WidgetsBooking')],1),_c('CCol',{attrs:{"col":"3"}},[_c('WidgetsCustomer')],1),_c('CCol',{attrs:{"col":"3"}})],1),_c('CRow',[_c('CCol',[_c('WidgetUpcomingBookings')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }